import { Modal } from 'antd';

import { Button } from '@shared/components/Button';

interface Props {
  isShowExceedLimitModal: boolean;
  onOk: () => void;
}
const ExceedLimitModal = ({ isShowExceedLimitModal, onOk }: Props) => (
  <Modal centered closable={false} footer={null} open={isShowExceedLimitModal}>
    <div className="mx-auto flex w-3/4 flex-col items-center justify-center text-center text-base">
      <b className="text-base">Error in uploading</b>
      <br />
      Please limit your image size to 15MB. <br />
      (Code: ICON0032)
      <Button className="json-checked mt-6 w-full" onClick={onOk}>
        OK
      </Button>
    </div>
  </Modal>
);

export default ExceedLimitModal;
